import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import mutations from '../../graphql/mutations';
import Dialog from '../overlay/Dialog';
import OverlayController from '../overlay/OverlayController';
import FlatButton from 'material-ui/FlatButton';
import { compose } from 'react-apollo';
import './BoardDialog.css';

class BoardDialog extends React.Component {

    constructor(props) {
        super(props);

        this.didClickSave = this.didClickSave.bind(this);
        this.didClickDelete = this.didClickDelete.bind(this);
        this.didClickApproveDelete = this.didClickApproveDelete.bind(this);

        let boardId = null;
        let boardName = '';
        let editMode = false;

        if (this.props.board !== null) {
            boardId = this.props.board.id;
            boardName = this.props.board.name;
            editMode = true;
        }

        this.state = {
            boardId,
            boardName,
            editMode
        };
    }

    didChangeBoardName(boardName) {
        this.setState({boardName});
    }

    didClickSave(event) {
        event.preventDefault();
        OverlayController.showActivityIndicator();

        let boardInput = {
            name: this.state.boardName.trim()
        };

        let actionPromise;
        if (this.state.editMode) {
            actionPromise = this.props.updateBoard(this.state.boardId, boardInput)
        } else {
            actionPromise = this.props.createBoard(this.props.projectId, boardInput)
        }

        actionPromise.then(() => {
            OverlayController.hideActivityIndicator();
            OverlayController.hideOverlay();
        }).catch((error) => {
            OverlayController.hideActivityIndicator();
            OverlayController.showErrorAlert(error);
        });
    }

    isSaveDisabled() {
        return this.state.boardName.trim().length === 0;
    }

    didClickDelete() {
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Delete', handler: this.didClickApproveDelete}
        ];
        OverlayController.showOverlay({
            component: <Dialog title={`Are you sure you want to delete ${this.props.board.name} board`} actions={actions} />
        });
    }

    didClickApproveDelete() {
        OverlayController.hideOverlay();
        OverlayController.showActivityIndicator();
        this.props.deleteBoard(this.state.boardId)
            .then(() => {
                OverlayController.hideActivityIndicator();
                OverlayController.hideOverlay();
            })
            .catch((error) => {
                OverlayController.hideActivityIndicator();
                OverlayController.showErrorAlert(error);
            });
    }

    render() {
        let formId = 'boardForm';
        let actions = [
            {label: 'Cancel', handler: () => OverlayController.hideOverlay()},
            {label: 'Save', type: "submit", form: formId, disabled: this.isSaveDisabled()}
        ];
        let title = this.state.editMode ? "Edit Board" : "Create Board";
        return (
            <Dialog showTitleBar={true} title={title} actions={actions} className="boardDialog">
                <form id={formId} onSubmit={this.didClickSave}>
                    <TextField
                        className="custom-field"
                        fullWidth={true}
                        floatingLabelText="Board Name"
                        floatingLabelFixed={true}
                        hintText="Enter title for the board"
                        value={this.state.boardName}
                        onChange={(event) => this.didChangeBoardName(event.target.value)}/>
                </form>
                {this.state.editMode &&
                    <div className="boardDeleteWrapper">
                        <FlatButton label="Delete Board" secondary={true} onTouchTap={this.didClickDelete}/>
                    </div>
                }
            </Dialog>
        );
    }

}

BoardDialog.propTypes = {
    projectId: PropTypes.string.isRequired,
    board: PropTypes.object
};
BoardDialog.defaultProps = {
    board: null
};

export default compose(
    mutations.createBoardMutationHoc,
    mutations.updateBoardMutationHoc,
    mutations.deleteBoardMutationHoc
)(BoardDialog);



// WEBPACK FOOTER //
// ./src/components/board/BoardDialog.js